import React from 'react';
import FilesystemRouter from './router/FilesystemRouter';

export default function Routes() {
  return <FilesystemRouter />;
}
